import { jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { Drawer } from "../../Drawer/index.js";
import { OverlayTitle } from "../../OverlaySearchHeader/index.js";
import { StickyActionBar } from "../../StickyActionBar/index.js";
import { TravelerSelectionContent } from "../TravelerSelectionContent/TravelerSelectionContent.js";
function TravelerSelectionMobile({ ageSelectEnabled, disclaimer, isOpen, handleClose, isHotel, lapInfantLabel, maxAdults, maxChildren, maxRooms, fireMaxRoomsOnClick, maxRoomsMessage, maxRoomsUrl, roomsEnabled, shouldCountLapInfant, state, subLabelMap }) {
    const Footer = useCallback(()=>{
        const handleDoneClick = ()=>{
            state.triggerValidation?.();
            handleClose();
        };
        return /*#__PURE__*/ jsx(StickyActionBar, {
            type: "primary",
            actionText: "Done",
            onClick: handleDoneClick,
            barType: "actionBar"
        });
    }, [
        handleClose,
        state
    ]);
    return /*#__PURE__*/ jsx(Drawer, {
        title: "Travelers",
        description: "Add your travelers",
        direction: "bottom",
        showCloseButton: false,
        showDragHandle: false,
        open: isOpen,
        scroll: "body",
        footer: /*#__PURE__*/ jsx(Footer, {}),
        headingCustomNode: /*#__PURE__*/ jsx(OverlayTitle, {
            heading: "Travelers",
            subHeading: state.label,
            handleClose: handleClose,
            slots: {
                container: 'px-4 pb-4'
            }
        }),
        children: /*#__PURE__*/ jsx("div", {
            className: "relative flex w-full p-4",
            children: /*#__PURE__*/ jsx(TravelerSelectionContent, {
                ageSelectEnabled: ageSelectEnabled,
                disclaimer: disclaimer,
                isHotel: isHotel,
                lapInfantLabel: lapInfantLabel,
                maxAdults: maxAdults,
                maxChildren: maxChildren,
                maxRooms: maxRooms,
                maxRoomsMessage: maxRoomsMessage,
                maxRoomsUrl: maxRoomsUrl,
                roomsEnabled: roomsEnabled,
                shouldCountLapInfant: shouldCountLapInfant,
                state: state,
                subLabelMap: subLabelMap,
                fireMaxRoomsOnClick: fireMaxRoomsOnClick
            })
        })
    });
}
const TravelerSelection_TravelerSelectionMobile = /*#__PURE__*/ memo(TravelerSelectionMobile);
export { TravelerSelection_TravelerSelectionMobile as default };
